import React, { useState } from "react";
import ClientSupport from "../../Components/ClientSupport/ClientSupport";
import ClientSupportCBA from "../../Components/ClientSupport/ClientSupportCBA";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";

function ClientSupportPage() {
  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main className="client-support-enquiries" id="main-content">
        <div className="d-flex justify-content-between">
          <h2 className="client-support-title">Support</h2>
          <div>
            <div className="filter-tabs">
              <ul className=" nav nav-tabs" id="pills-tab" role="tablist">
                {/* <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="pills-client-tab"
                    data-toggle="pill"
                    data-target="#pills-client"
                    type="button"
                    role="tab"
                    aria-controls="pills-client"
                    aria-selected="true"
                  >
                    Client
                  </button>
                </li> */}
                {/* <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-cba-tab"
                    data-toggle="pill"
                    data-target="#pills-cba"
                    type="button"
                    role="tab"
                    aria-controls="pills-cba"
                    aria-selected="false"
                  >
                    CBA
                  </button>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
        <div className="tab-content" id="pills-tabContent">
          {/* client tab */}
          <ClientSupport />
          {/* CBA tab */}
          {/* <ClientSupportCBA/> */}
        </div>
      </main>
    </>
  );
}
export default ClientSupportPage;
